import request from '@/plugin/axios'
const newCenterService = 'hm-news-center'
const hmTaxerawebsite = 'hm-taxerawebsite'
const hmTaxRegulatory = 'hm-tax-regulatory'
const hmWebsiteMidway = 'hm-website-midway'
// ng配置中的转发前缀
const ngProxy = '/api/japi'

/*
  api命名规则（请求方式+apiurl驼峰）
  例：/api/v1/service-price
  命名：getServicePrice
*/
// 查省市地址字典
export const PostQueryCodeLibraryList = (data)=> {
  return request({
    proxy: ngProxy,
    service: hmTaxRegulatory,
    url: '/codeLibrary/queryCodeLibraryList',
    method: 'post',
    data
  })
}
// c财税沙龙文章详情
export const PostSalonTaxInformationFindById = data => {
  return request({
    // proxy: ngProxy,
    service: hmWebsiteMidway,
    url: '/midway/salonTaxInformation/findById',
    method: 'post',
    data
  })
}
// c财税沙龙文章列表
export const PostSalonTaxInformation = data => {
  return request({
    // proxy: ngProxy,
    service: hmWebsiteMidway,
    url: '/midway/salonTaxInformation/find',
    method: 'post',
    data
  })
}
// c财税沙龙提问
export const PostWebsiteMessageAdd = data => {
  return request({
    // proxy: ngProxy,
    service: hmWebsiteMidway,
    url: '/midway/websiteMessage/create',
    method: 'post',
    data
  })
}
// 员工活动列表
export const PostEmployeeActivity = data => {
  return request({
    // proxy: ngProxy,
    service: hmWebsiteMidway,
    url: '/midway/employeeActivity/find',
    method: 'post',
    data
  })
}
// 员工活动列表详情
export const PostEmployeeActivityDetail = data => {
  return request({
    // proxy: ngProxy,
    service: hmWebsiteMidway,
    url: '/midway/employeeActivity/findById',
    method: 'post',
    data
  })
}
// 员工心声列表
export const PostEmployeeVoic = data => {
  return request({
    // proxy: ngProxy,
    service: hmWebsiteMidway,
    url: '/midway/employeeVoice/find',
    method: 'post',
    data
  })
}
// 部门信息列表
export const PostPartmentInfo = data => {
  return request({
    // proxy: ngProxy,
    service: hmWebsiteMidway,
    url: '/midway/partmentInfo/find',
    method: 'post',
    data
  })
}
// 岗位列表
export const PostRecruitmentInformation = data => {
  return request({
    // proxy: ngProxy,
    service: hmWebsiteMidway,
    url: '/midway/recruitmentInformation/find',
    method: 'post',
    data
  })
}
// 岗位详情
export const PostRecruitmentInformationDetail = data => {
  return request({
    // proxy: ngProxy,
    service: hmWebsiteMidway,
    url: '/midway/recruitmentInformation/findById',
    method: 'post',
    data
  })
}
// 简历提交
export const PostResumeInformation = data => {
  return request({
    // proxy: ngProxy,
    service: hmWebsiteMidway,
    url: '/midway/resumeInformation/create',
    method: 'post',
    data
  })
}
// 批量新增图片数据
export const PostBatchInsert = (data) => {
  return request({
    proxy: '/doc',
    url: '/a/hml/documentNoAuth/batchInsertNoAuth',
    method: 'post',
    data
  })
}

// 根据id更新模板文件
export const PostUpdateTemplateByIdNoAuth = (data) => {
  return request({
    proxy: '/doc',
    url: '/a/hml/documentNoAuth/updateTemplateByIdNoAuth',
    method: 'post',
    data
  })
}
// 试用申请
export const PostProbationQuestions = data => {
  return request({
    proxy: ngProxy,
    service: hmTaxerawebsite,
    url: '/product/probationQuestions',
    method: 'post',
    data
  })
}
// 发送验证码
export const GetSendVerificationCode = params => {
  return request({
    proxy: ngProxy,
    service: hmTaxerawebsite,
    url: '/product/sendVerificationCode',
    method: 'get',
    params
  })
}
// 查询新闻中心-新闻文档列表
export const PostQueryNewsDocumentList = data => {
  return request({
    throttle: false,
    proxy: ngProxy,
    service: newCenterService,
    url: '/newsDocument/queryNewsDocumentList',
    method: 'post',
    data
  })
}

// id查询新闻文档
export const GetQueryNewsDocumentById = params => {
  return request({
    throttle: false,
    proxy: ngProxy,
    service: newCenterService,
    url: '/newsDocument/queryNewsDocumentById',
    method: 'get',
    params
  })
}

// 查询上一篇下一篇
export const PostQueryNewsDocumentLastAndNext = data => {
  return request({
    throttle: false,
    proxy: ngProxy,
    service: newCenterService,
    url: '/newsDocument/queryNewsDocumentLastAndNext',
    method: 'post',
    data
  })
}

// 查询官网-banner
export const PostQueryOfficialBannerList = data => {
  return request({
    throttle: false,
    proxy: ngProxy,
    service: newCenterService,
    url: '/officialBanner/queryOfficialBannerList',
    method: 'post',
    data
  })
}

// 查询研讨活动-详情信息列表
export const PostQueryActivityDetailsList = data => {
  return request({
    throttle: false,
    proxy: ngProxy,
    service: newCenterService,
    url: '/activityDetails/queryActivityDetailsList',
    method: 'post',
    data
  })
}

// 查询研讨活动-详情信息根据id
export const GetQueryActivityDetailsById = params => {
  return request({
    throttle: false,
    proxy: ngProxy,
    service: newCenterService,
    url: '/activityDetails/queryActivityDetailsById',
    method: 'get',
    params
  })
}
export function PostPartmentInfoList (data) {
  return request({
    service: hmWebsiteMidway,
    url: '/midway/partmentInfo/find',
    method: 'post',
    data
  })
}


// WEBPACK FOOTER //
// ./src/api/api.js